import contractTypes from "../enums/contractTypes";

export function areAllContractsCompleted(data, systemId) {
    const target = data.find(item => item.id === systemId);
    if (!target || target.incomplete_agreements.length === 0) return false;

    const agreements = target.incomplete_agreements;
    const hasUpfront = agreements.srec_agreement?.has_upfront_payment ?? true;

    return Object.entries(agreements).every(([key, value]) => {
        if (key === "security_addendum" && !hasUpfront) {
            return true; // skip check
        }
        return value.is_completed === true;
    });
}

export const getStepNamesForContractStepper = (incompleteAgreements, systemId, userPaymentMethodType) => {
    const target = incompleteAgreements.find(item => item.id === systemId);
    let stepNames = [];
    if (!target || target.incomplete_agreements.length === 0) {
        if (!userPaymentMethodType) {
            stepNames.push('Payment Method');
            return stepNames;
        }
        return false;
    }
    const agreements = target.incomplete_agreements;
    stepNames = Object.keys(agreements)
        .filter(key => {
            if (key === 'security_addendum') {
                return agreements['srec_agreement']?.has_upfront_payment === true;
            }
            return true;
        })
        .map(key => contractTypes[key])
        .filter(Boolean);

    if (!userPaymentMethodType) {
        stepNames.push('Payment Method');
    }

    return stepNames;
};